<template>
    <div class="box">
        <inner-table id="innerDormitory" ref="dormitoryList" :listviewurl="'xsgl.xsglCheckIn.studentList'" :exclude-fields="'name,studentId,studentBasicInfoId,schoolDormitoryId,gender,column_operate'" :can-edit="0" :can-delete="0" :link-prop-name="'studentId'" />
        <!-- <inner-table id="innerFamily" ref="familyList" :listviewurl="'studentFamilyMembers.list'" :can-edit="1" :can-delete="canEdit" :link-prop-name="'studentId'"/> -->

    </div>
</template>

<script>
export default {
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        onInnerCellClick(){

        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            console.log('$scope', $scope)

            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #999;
   padding-bottom: 1px;
}
</style>

